import styled from 'styled-components'

  // Used to create a box around text to place ButtonBack
  const Sub = styled.div`
    position: relative;
    display: inline-block;
    margin-bottom: 12px;
  `;

export default Sub